'use client';

import type { JSX } from 'react';
import React from 'react';
import sanitize from '@/Util/sanitize';
import dynamic from 'next/dynamic';
const AccordionElementList = dynamic(() => import('@/components/accordion/AccordionElementList'));
import type { ApiInfoSection } from '../../../api/model';

const AccordionElementListWrapper = ({
  infoSectionsEntry
}: {
  infoSectionsEntry: ApiInfoSection[];
}): JSX.Element => {
  return (
    <AccordionElementList
      items={infoSectionsEntry}
      bodyCb={item => (
        <div className="accordion-element__section__container">
          <div
            className="accordion-element__section__text"
            dangerouslySetInnerHTML={{ __html: sanitize(item.description, true) }}
          />
        </div>
      )}
      headerCb={item => <div className="intro__container__accordionHeadline">{item.headline}</div>}
      indexerProp="description"
      openAllInitially
    />
  );
};

export default AccordionElementListWrapper;
